import { AccountVariable, AccountVariableType } from '@/client/accounts';

export const POINT_OF_CONTACT_FORMAT = 'point-of-contact';
export const POINT_OF_CONTACT_TYPE_ATTRIBUTE = 'data-poc-type';

export const withExamplePointOfContact = (
  accountVariables: AccountVariable[] | undefined,
  t: (key: string) => string,
): AccountVariable[] => {
  const hasItContact = accountVariables?.some(
    (variable) =>
      variable.type === AccountVariableType.IT_CONTACT &&
      variable.value?.name?.trim(),
  );

  if (hasItContact) return accountVariables ?? [];

  return [
    ...(accountVariables ?? []),
    {
      id: 'it-contact-example',
      type: AccountVariableType.IT_CONTACT,
      value: {
        name: t('course.pointOfContact.previewExample.name'),
        email: t('course.pointOfContact.previewExample.email'),
        phone: t('course.pointOfContact.previewExample.phone'),
        openingHours: t('course.pointOfContact.previewExample.openingHours'),
      },
      created: '',
    },
  ];
};
